var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 35,
  fill: "none",
  viewBox: "0 0 28 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#005D98",
  d: "M27.508 11.813a3.33 3.33 0 0 0-2.842-1.618h-6.922l2.113-6.117c.291-.984.073-1.969-.583-2.812C18.618.492 17.671 0 16.651 0H7.105c-1.676 0-3.06 1.266-3.28 2.672L.038 17.578c-.146.985.146 1.899.801 2.672.656.703 1.676 1.125 2.696 1.125h7.142l-2.55 10.688a3.32 3.32 0 0 0 .582 2.742A3.4 3.4 0 0 0 11.331 36c1.24 0 2.332-.562 2.842-1.477l13.335-19.476c.656-.985.656-2.18 0-3.235"
})));
export default SvgPowerActive;